import api from './api';
import { Ride, RideFilters, RideResponse, RideStats } from '../types';

export const rideService = {
  async getRides(filters: RideFilters = {}): Promise<RideResponse> {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });

    const response = await api.get(`/rides?${params.toString()}`);
    return response.data;
  },

  async getRide(id: string): Promise<Ride> {
    const response = await api.get(`/rides/${id}`);
    return response.data;
  },

  async updateRideStatus(id: string, status: string, notes?: string): Promise<Ride> {
    const response = await api.patch(`/rides/${id}/status`, { status, notes });
    return response.data.ride;
  },

  async updateRideDetails(id: string, details: {
    from?: string;
    to?: string;
    time?: string;
    price?: string;
    contactName?: string;
    vehicleType?: string;
  }): Promise<Ride> {
    const response = await api.patch(`/rides/${id}/details`, details);
    return response.data.ride;
  },

  async assignDriver(id: string, driverId: string): Promise<Ride> {
    const response = await api.patch(`/rides/${id}/assign`, { driverId });
    return response.data.ride;
  },

  async getRideStats(): Promise<RideStats> {
    const response = await api.get('/rides/stats/overview');
    return response.data;
  },

  async deleteRide(id: string): Promise<void> {
    await api.delete(`/rides/${id}`);
  },

  async getAiCostStats(days = 14): Promise<{
    days: number;
    rows: { _id: string; totalMessages: number; rideRelated: number; filtered: number; costUsd: number }[];
    totals: { totalMessages: number; costUsd: number; rideRelated: number };
  }> {
    const response = await api.get(`/rides/stats/ai-cost?days=${days}`);
    return response.data;
  },

  async getHeatmapData(days = 30): Promise<{
    days: number;
    pickups: { location: string; count: number }[];
    dropoffs: { location: string; count: number }[];
    groupActivity: { group: string; count: number }[];
  }> {
    const response = await api.get(`/rides/stats/heatmap?days=${days}`);
    return response.data;
  },

  async getGroupSuggestions(days = 30): Promise<{
    days: number;
    suggestions: {
      groupId: string; groupName: string; accountName: string;
      rideCount: number; avgConfidence: number; highPriorityCount: number;
      lastRideAt: string; score: number; recommendation: 'high' | 'medium' | 'low';
    }[];
  }> {
    const response = await api.get(`/rides/stats/group-suggestions?days=${days}`);
    return response.data;
  },
};
